import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import {getDayWiseData, getMonthWiseData, getPlazaTrandChartData, getWeekWiseData, getRepeatedViolationsChartData,getNPCI_VCTrand, getMapped_AVC_Trand} from '../../../common/apiService';
import CommonDateRangePicker from '../../../common/daterangepicker';
import { UserContext } from '../../../contexts/UserContext';
import '../ViolationsAnalytics/violationAnaltics.css';
import { getJsonData } from '../../../service/utilService'



export default function ViolationAnaltics() {
    const userDetail = useContext(UserContext);
    const [violationTrandStatusChart, setViolationTrandStatusChart] = useState([]);
    const [npciClassData, setNpciClassesData] = useState([]);
    const [vcClassData, setvcClassesData] = useState([]);
    const [topTollPlazaChart, setTopTollPlazaChart] = useState([]);
    const [keyName, setKeyName] = useState("date");
    const [repeatedviochart, setReaptedVioChart] = useState([]);
    const [vehicleClassName, setVehicleClassName] = useState("");
    const [approveCount, setApproveCount] = useState("");
    const [rejectCount, setRejectCount] = useState("");


    const [trandChartLoader,setTransChartLoader] = useState(false);
    const [repeatViolationLoader,setRepeatViolationLoader] = useState(false);
    const [topTollPlazaLoader,setTopTollPlazaLoader] = useState(false);
    const [npciClassChartLoader,setNpciClassChartLoader] = useState(false);
    const [vcClassChartLoader,setVcClassChartLoader] = useState(false);

    const [jsonData, setJsonData] = useState(getJsonData(userDetail));

    useEffect(() => {
        getTrandChartData(keyName);
        plazaTrends();
        getRepeatViolationChartData();
        getNPCIChartData()
    },[jsonData,userDetail ])


    const getRequestJson=()=>{
        if (Array.isArray(jsonData.plazaIds)) {
            jsonData.plazaIds = jsonData.plazaIds.join(",");
        }
        const json = {
            ...jsonData,
            startDate:jsonData.startDate.split("T")[0],
            endDate:jsonData.endDate.split("T")[0]
        }
        return json;
    }

    //  Funcion for get top toll Plaza chart data 
    const plazaTrends=() => {
        let json = getRequestJson();
        setTopTollPlazaLoader(true);
        getPlazaTrandChartData(json).then(({data})=>{
        setTopTollPlazaLoader(false);
            let userPlazaIds = userDetail?.plaza;
          let chartdata = data.filter((e)=>  userPlazaIds.includes(e.plazaId))
          let finalChartArr =[];
          if(chartdata?.length>0){
             let plazaArr = chartdata.map((e)=> e.plazaId );
             let uniquePlazaArr = [...new Set(plazaArr)]
             uniquePlazaArr.forEach((plaza)=>{
                let arr = chartdata.filter((e)=> e.plazaId==plaza);

                let raised_count = 0,approved_count = 0,rejected_count = 0,raised_amt = 0,approved_amt = 0,rejected_amt = 0;
                for(let i=0; i<arr.length; i++){
                    let json = arr[i];
                    if(json.remark==='Accept'){
                        approved_count += +json.count;
                        approved_amt += +json.sum;
                    } else if(json.remark==='Reject'){
                        rejected_count += +json.count;
                        rejected_amt += +json.sum;
                    }
                }

                raised_count = approved_count + rejected_count;
                raised_amt = approved_amt + rejected_amt;
                
                let finalJson =  {
                    plaza: plaza,
                    raised_count ,
                    approved_count,
                    rejected_count,
                    raised_amt,
                    approved_amt,
                    rejected_amt,
                }
                finalChartArr.push(finalJson);
             })
            }
            finalChartArr.sort((a,b)=>  b.raised_count - a.raised_count );
            setTopTollPlazaChart(finalChartArr.slice(0,10));

        }).catch(()=>{
        setTopTollPlazaLoader(false);
        setTopTollPlazaChart([]);
        });

    }

    const getTrandChartData = (mode)=> {
        let keyname = '';
        if (mode === 'date') {
            keyname = "date"
            getDayWiseChartData();

        } else if (mode === 'week') {
            keyname = "week"
            getWeekWiseChartData();

        } else {
            keyname = "month";
            getMonthWiseChartData();
        }
        setKeyName(keyname);

    }

    let mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const getMonthWiseChartData = ()=>{ 
        let json = getRequestJson();
        setTransChartLoader(true);
        getMonthWiseData(json).then(({data})=>{
        setTransChartLoader(false);
        let finalChartArr =[];
            let trandChartData = data;
            if(trandChartData?.length > 0){
            let monthArr = data.map(e=> new Date(e.date).getMonth());
            let uniqueMonth = [...new Set(monthArr)];
            uniqueMonth.forEach(month=>{
            let arr = trandChartData.filter(e=> new Date(e.date).getMonth() === month);
            let raised_count = 0,approved_count = 0,rejected_count = 0,raised_amt = 0,approved_amt = 0,rejected_amt = 0;

            for(let i=0; i<arr.length; i++){
                let json = arr[i];
                if(json.status==='Accept'){
                    approved_count += +json.count;
                    approved_amt += +json.sumAmount;
                } else if(json.status==='Reject'){
                    rejected_count += +json.count;
                    rejected_amt += +json.sumAmount;
                }
            }
            raised_count = approved_count + rejected_count;
                raised_amt = approved_amt + rejected_amt;
                
            let finalJson =  {
                month:mS[month],
                year: new Date(arr[0].date).getFullYear(),
                raised_count ,
                approved_count,
                rejected_count,
                raised_amt,
                approved_amt,
                rejected_amt,
            }
            finalChartArr.push(finalJson);

            })
        }
        setViolationTrandStatusChart(finalChartArr);
        }).catch((err)=>{
        setTransChartLoader(false);
        setViolationTrandStatusChart([]);
        })
    }
    
    const getDayWiseChartData = ()=>{ 
        let json = getRequestJson();
        setTransChartLoader(true);
        getDayWiseData(json).then(({data})=>{
            setTransChartLoader(false);
            let finalChartArr =[];
            let trandChartData = data;
            if(trandChartData?.length > 0){
            let dayArr = data.map(e=> new Date(e.date).getDate()-1 + "#" + e.date.split("T")[0]);
            let uniqueDay = [...new Set(dayArr)];
            uniqueDay.sort((a,b)=>a.split("#")[0]-b.split("#")[0]);
            uniqueDay.forEach(daily=>{
            let arr = trandChartData.filter(e=> Number(new Date(e.date).getDate()-1) === +daily.split("#")[0]);
            let raised_count = 0,approved_count = 0,rejected_count = 0,raised_amt = 0,approved_amt = 0,rejected_amt = 0;
            for(let i=0; i<arr.length; i++){
                let json = arr[i];
                if(json.status==='Accept'){
                    approved_count += +json.count;
                    approved_amt += +json.sumAmount;
                } else if(json.status==='Reject'){
                    rejected_count += +json.count;
                    rejected_amt += +json.sumAmount;
                }
            }
            raised_count = approved_count + rejected_count;
            raised_amt = approved_amt + rejected_amt;

            let finalJson =  {
                date:daily.split("#")[1],
                raised_count ,
                approved_count,
                rejected_count,
                raised_amt,
                approved_amt,
                rejected_amt,
            }
            finalChartArr.push(finalJson);

            })
        }
        setViolationTrandStatusChart(finalChartArr);
        }).catch((err)=>{
        setTransChartLoader(false);
        setViolationTrandStatusChart([]);
        })
    }
    
    const getWeekNumber = (d)=> {
            var firstWeekday = new Date(new Date(d).getFullYear(), new Date(d).getMonth(), 1).getDay() - 1;
            if (firstWeekday < 0) firstWeekday = 6;
            var offsetDate = new Date(d).getDate() + firstWeekday - 1;
            return Math.floor(offsetDate / 7);
    }

    const getWeekWiseChartData = ()=>{ 
        let json = getRequestJson();
        setTransChartLoader(true);
        getWeekWiseData(json).then(({data})=>{
            setTransChartLoader(false);
            let finalChartArr =[];
            let trandChartData = data;
            if(trandChartData?.length > 0){
            let weekArr = data.map(e=> getWeekNumber(e.date) + "#" + e.date);
            let uniqueWeek = [...new Set(weekArr)];
            uniqueWeek.sort((a,b)=>a.split("#")[0]-b.split("#")[0]);
            uniqueWeek.forEach(week=>{
            let arr = trandChartData.filter(e=> getWeekNumber(e.date) === +week.split("#")[0]);
            let raised_count = 0,approved_count = 0,rejected_count = 0,raised_amt = 0,approved_amt = 0,rejected_amt = 0;
            for(let i=0; i<arr.length; i++){
                let json = arr[i];
                if(json.status==='Accept'){
                    approved_count += +json.count;
                    approved_amt += +json.sumAmount;
                } else if(json.status==='Reject'){
                    rejected_count += +json.count;
                    rejected_amt += +json.sumAmount;
                }
            }
            raised_count = approved_count + rejected_count;
            raised_amt = approved_amt + rejected_amt;

            let finalJson =  {
                week: week.split("#")[0]+"-Week ("+mS[new Date(week.split("#")[1]).getMonth()]+")" ,
                raised_count ,
                approved_count,
                rejected_count,
                raised_amt,
                approved_amt,
                rejected_amt,
            }
            finalChartArr.push(finalJson);
            })
        }
        setViolationTrandStatusChart(finalChartArr);
        }).catch((err)=>{
        setTransChartLoader(false);
        setViolationTrandStatusChart([]);
        })
    }

    const getRepeatViolationChartData=()=>{
        let json = getRequestJson();
        setRepeatViolationLoader(true)
         getRepeatedViolationsChartData(json).then((res)=>{
            const chartdata = res.data;
            setReaptedVioChart(chartdata);
            setRepeatViolationLoader(false)
        }).catch(()=>{
            setRepeatViolationLoader(false)
        });
    }


   const getNPCIChartData = ()=> {
    let json = getRequestJson();
    setNpciClassChartLoader(true);
    getNPCI_VCTrand(json).then(res=>{
    setNpciClassChartLoader(false);
    let finalChartArr =[];
            let chartdata = res.data;
            if(chartdata?.length > 0){
            let npciClassArr = chartdata.map(e=> e.npciVehicleClass);
            let uniqueNpciClass = [...new Set(npciClassArr)];
            uniqueNpciClass.forEach(npciClass=>{
            let arr = chartdata.filter(e=> e.npciVehicleClass === npciClass);
            let raised_count = 0,approved_count = 0,rejected_count = 0,raised_amt = 0,approved_amt = 0,rejected_amt = 0;
            for(let i=0; i<arr.length; i++){
                let json = arr[i];
                if(json.remark==='Accept'){
                    approved_count += +json.count;
                    approved_amt += +json.sum;
                } else if(json.remark==='Reject'){
                    rejected_count += +json.count;
                    rejected_amt += +json.sum;
                }
            }
            raised_count = approved_count + rejected_count;
            raised_amt = approved_amt + rejected_amt;

            let finalJson =  {
                npcl_class:npciClass,
                raised_count ,
                approved_count,
                rejected_count,
                raised_amt,
                approved_amt,
                rejected_amt,
            }
            finalChartArr.push(finalJson);
            })
        }
        setNpciClassesData(finalChartArr.sort((a,b)=>{
        return a.npcl_class.replace("VC","") - b.npcl_class.replace("VC","")
        }));
        getVehicleClasses(finalChartArr[0])
    }).catch(res=>{
    setNpciClassChartLoader(false);
    getVehicleClasses([]);
    })
   }



    const getVehicleClasses = (e) => {
        setVcClassChartLoader(true);
        setVehicleClassName(e.npcl_class)
        setApproveCount((e.approved_count || 0 )+" ("+Number(((e.approved_count / e.raised_count ) * 100) || 0).toFixed(2)+"%)");
        setRejectCount((e.rejected_count || 0 )+" ("+Number(((e.rejected_count / e.raised_count ) * 100) || 0).toFixed(2)+"%)");
        let json = getRequestJson();
        getMapped_AVC_Trand(json,e.npcl_class).then(res=>{
        setVcClassChartLoader(false);
        let finalChartArr =[];
            let chartdata = res.data;
            if(chartdata?.length > 0){
            let mappedAvcArr = chartdata.map(e=> e.mappedAvc);
            let uniqueMappedAvc = [...new Set(mappedAvcArr)];
            uniqueMappedAvc.forEach(mappedAvc=>{
            let arr = chartdata.filter(e=> e.mappedAvc === mappedAvc);
            let raised_count = 0,approved_count = 0,rejected_count = 0,raised_amt = 0,approved_amt = 0,rejected_amt = 0;
            for(let i=0; i<arr.length; i++){
                let json = arr[i];
                if(json.remark==='Accept'){
                    approved_count += +json.count;
                    approved_amt += +json.sum;
                } else if(json.remark==='Reject'){
                    rejected_count += +json.count;
                    rejected_amt += +json.sum;
                }
            }
            raised_count = approved_count + rejected_count;
            raised_amt = approved_amt + rejected_amt;

            let finalJson =  {
                vc_class:mappedAvc,
                raised_count ,
                approved_count,
                rejected_count,
                raised_amt,
                approved_amt,
                rejected_amt,
            }
            finalChartArr.push(finalJson);
            })
        }
        setvcClassesData(finalChartArr.sort((a,b)=> a.vc_class.replace("VC","") - b.vc_class.replace("VC","")));
        }).catch(err=>{
            setVcClassChartLoader(false);
        })
    }
        
    const CustomTooltip = ({ active, payload, label, data }) => {
        if (active && payload) {
            const payload0 = payload[0];
            const payload1 = payload[1];
            const payload2 = payload[2];
            return (
                <div className="line-chart_custom-tooltip">
                    <p>{payload0.payload.month} {payload0.payload.year} {payload0.payload.week}</p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload0.stroke }}></span> Raised : {payload0.value} ({payload0.payload.raised_amt}) </p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload1.stroke }}></span> Approved : {payload1.value} ({payload1.payload.approved_amt}) </p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload2.stroke }}></span> Rejected : {payload2.value} ({payload2.payload.rejected_amt}) </p>
                </div>
            );
        }
        return null;
    }; 
    const CustomTooltip1 = ({ active, payload, label, data }) => {
        if (active && payload) {
            const payload0 = payload[0];
            const payload1 = payload[1];
            return (
                <div className="line-chart_custom-tooltip">
                    <p>Plaza : {payload0.payload.plaza}</p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: '#B5B5B5' }}></span> Raised : {+payload0.value + +payload1.value} ({+payload0.payload.approved_amt + +payload1.payload.raised_amt}) </p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload0.fill }}></span> Approved : {payload0.value} ({payload0.payload.approved_amt}) </p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload1.fill }}></span> Rejected : {payload1.value} ({payload1.payload.rejected_amt}) </p>
                </div>
            );
        }
        return null;
    };
    
    const RepeatViolationCustomTooltip = ({ active, payload, label, data }) => {
        if (active && payload) {
            return (
                <div className="line-chart_custom-tooltip">
                    <p className="label"> Tag Counts : {+payload[0].value} </p>
                </div>
            );
        }
        return null;
    };
    const VCAnalysisCustomTooltip = ({ active, payload, label, data }) => {
        if (active && payload) {
            const payload0 = payload[0];
            const payload1 = payload[1];
            return (
                <div className="line-chart_custom-tooltip">
                    <p>Class : {payload0.payload.npcl_class} {payload0.payload.vc_class}</p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: '#B5B5B5' }}></span> Raised : {+payload0.value + +payload1.value} ({+payload0.payload.approved_amt + +payload1.payload.raised_amt}) </p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload0.fill }}></span> Approved : {payload0.value} ({payload0.payload.approved_amt}) </p>
                    <p className="label"><span className="color-dot" style={{ backgroundColor: payload1.fill }}></span> Rejected : {payload1.value} ({payload1.payload.rejected_amt}) </p>
                </div>
            );
        }
        return null;
    };




    return (
        <>
            <Tabs>
                <div className="row violationtab">
                    <div className="col-md-6 ">
                        <TabList>
                            <Tab>Violation Analysis</Tab>
                            <Tab>VC Analysis</Tab>
                        </TabList>
                    </div>
                    <div className="col-md-6 option">
                        <CommonDateRangePicker
                            plazaClassName="tollfilter"
                            datepickerClassName="daterange"
                            setjsonData={setJsonData}
                        />
                    </div>
                </div>
                <TabPanel>
                    <div className="ch_container1">
                    <Loader className="loader"
                    type="ThreeDots"
                    color="#9c1d26"
                    height={100}
                    width={100}
                    style= {{top:70}}
                   visible={trandChartLoader} />
                        <div className="row">
                            <div className="col-md-6">
                                <p className="vio_head">Violation trend by status</p><br /></div>
                            <div className="col-md-6">
                                <Button variant="link" style={{ border: 'none', float: 'right' }} className={keyName === 'month' && "mode-btn_active"} onClick={() => getTrandChartData('Month')} >
                                    Monthly
                                </Button>
                                <Button variant="link" style={{ border: 'none', float: 'right' }} className={keyName === 'week' && "mode-btn_active"} onClick={() => getTrandChartData('week')} >
                                    Weekly
                                </Button>
                                <Button variant="link" style={{ border: 'none', float: 'right' }} className={keyName === 'date' && "mode-btn_active"} onClick={() => getTrandChartData('date')} >
                                    Daily
                                </Button>
                            </div>
                        </div>

                        <div className="row scrollY" style={{position:'relative'}}>
                        {violationTrandStatusChart.length>0 ? <>
                            <ResponsiveContainer height={250} width='98%'>
                                <LineChart
                                    data={violationTrandStatusChart}
                                    margin={{
                                        top: 0,
                                        right: 30,
                                        left: 20,
                                        bottom: 5
                                    }}
                                >
                                    <CartesianGrid vertical={false} stroke="#575757" strokeDasharray="3" />
                                    <XAxis dataKey={keyName} />
                                    <YAxis yAxisId="left" tickLine={false} axisLine={false} tickMargin={8} label={{ value: 'Raised Violations', angle: -90, position: 'insideLeft', stroke: "#B2ACAC" }} />
                                    {<Tooltip content={<CustomTooltip />} />}
                                    <Line yAxisId="left" dataKey="raised_count" stroke="#B5B5B5" activeDot={{ r: 5 }} strokeWidth={2} />
                                    <Line yAxisId="left" dataKey="approved_count" stroke="#0076FF" activeDot={{ r: 5 }} strokeWidth={2} />
                                    <Line yAxisId="left" dataKey="rejected_count" values="20" stroke="#FDA629" activeDot={{ r: 5 }} strokeWidth={2} />
                                </LineChart>
                            </ResponsiveContainer>
                            <div className="axis_category">
                                <p>Time duration</p>
                            </div></>
                            : <> {!vcClassChartLoader && <p className="no-record-found">No Record Found!</p>} </>}
                        </div>
                    </div>
                    <div className="ch-container2">
                        <div className="vio_chart">
                        <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={repeatViolationLoader} />
                            <p className="vio_head" style={{ color: '#707070' }}>Tags identification for repeat violations</p><br />
                            {repeatedviochart.length>0 ? <>
                            <ResponsiveContainer height={350} width='98%'>
                                <BarChart
                                    width={500}
                                    height={300}
                                    data={repeatedviochart}
                                    margin={{
                                        top: 20,
                                        right: 10,
                                        left: 10,
                                        bottom: 5
                                    }}
                                >
                                    <CartesianGrid vertical={false} stroke="#e1e1e1" strokeDasharray="2" />
                                    <XAxis dataKey="noOfViolations" />
                                    <YAxis dataKey="tagCounts" tickLine={false} axisLine={false} tickMargin={15} label={{ value: 'Tag Counts', angle: -90, position: 'insideLeft', stroke: "#E4E4E4" }} />
                                    {<Tooltip content={<RepeatViolationCustomTooltip />} />}
                                    <Bar dataKey="tagCounts" stackId="a" barSize={62} fill="#3576ff" />
                                </BarChart>
                            </ResponsiveContainer>
                            <div className="axis_category">
                                <p>No. of violations</p>
                            </div></>
                            : <>{!repeatViolationLoader && <p className="no-record-found">No Record Found!</p>}</>}
                        </div>
                        <div className="vio_chart">
                        <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={topTollPlazaLoader} />
                            <p className="vio_head" style={{ color: '#707070' }}>Plaza by violation count</p><br />
                           {topTollPlazaChart.length>0 ? <>
                            <ResponsiveContainer height={350} width='98%'>
                                <BarChart
                                    width={32}
                                    height={169}
                                    data={topTollPlazaChart}
                                    margin={{
                                        top: 10,
                                        right: 0,
                                        left: 10,
                                        bottom: 5
                                    }}
                                >
                                    <CartesianGrid vertical={false} stroke="#e1e1e1" strokeDasharray="2" />
                                    <XAxis dataKey="plaza" />
                                    <YAxis dataKey="raised_count" tickLine={false} axisLine={false} tickMargin={15} label={{ value: 'Raised Violations', angle: -90, position: 'insideLeft', stroke: "#E4E4E4" }} />
                                    {<Tooltip content={<CustomTooltip1 />} />}
                                    <Bar dataKey="approved_count" stackId="a" barSize={31} fill="#f5a604" />
                                    <Bar dataKey="rejected_count" stackId="a" barSize={31} fill="#3576ff" />
                                </BarChart>
                            </ResponsiveContainer>
                            <div className="axis_category">
                                <p>Toll Plaza</p>
                            </div></>
                            : <>{!topTollPlazaLoader &&  <p className="no-record-found">No Record Found!</p>} </>}
                        </div>
                    </div>

                    {/* Violations Analysis Charts end here */}

                    {/* VC Analysis Charts Start  */}

                </TabPanel>
                <TabPanel>
                    <div className="ch-container2">
                        <div className="vio_chart npci_chart">
                        <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={npciClassChartLoader} />
                            <p className="vio_head" style={{ color: '#707070' }}>Raised violation by NPCI Vehicle Class</p><br />
                           {npciClassData.length>0 ? <>
                            <ResponsiveContainer height={560}>
                                <BarChart
                                    width={500}
                                    height={300}
                                    data={npciClassData}
                                    layout="vertical"
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5
                                    }}
                                >
                                    <XAxis dataKey="raised_count" type="number" tick={false} tickLine={false} axisLine={false} />
                                    <YAxis dataKey="npcl_class" type="category" tickMargin={15} tickvalue={false} tickLine={false} axisLine={false} label={{ value: 'Vehicle Classes', angle: -90, position: 'insideLeft', stroke: "#B2ACAC" }} />
                                    {<Tooltip content={<VCAnalysisCustomTooltip />} />}
                                    <Bar dataKey="approved_count" stackId="a" fill="#f5a604" barSize={28} onClick={getVehicleClasses} />
                                    <Bar dataKey="rejected_count" stackId="a" fill="#3576ff" barSize={28} onClick={getVehicleClasses} />
                                </BarChart>
                            </ResponsiveContainer>
                            <div className="axis_category">
                                <p>Raised Violation </p>
                            </div></>
                            : <p className="no-record-found">No Record Found!</p>}
                        </div>
                        <div className="vio_chart">
                        <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={vcClassChartLoader} />
                            <p className="vio_head" style={{ color: '#707070', fontSize: 22, fontWeight: 'normal' }}>Violation status for Vehicle Class : <b>&nbsp; {vehicleClassName}</b></p>
                            <div col-md-6 className="vio_staus">
                                <div className="col-md-4 legend-text" > <span className="color-dot" style={{ backgroundColor: '#f5a604' }} /> Approved : {approveCount}</div>
                                &nbsp; &nbsp;<div className="col-md-4 legend-text" > <span className="color-dot" style={{ backgroundColor: '#3576ff' }} /> Rejected : {rejectCount}</div>
                            </div>
                            <hr style={{ color: '#C9C9C9' }} />
                            <p className="vio_npci">AVC assessment again NPCI Class</p>
                           {vcClassData.length>0 ? <>
                            <ResponsiveContainer height={500}>
                                <BarChart
                                    data={vcClassData}
                                    layout="vertical"
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5
                                    }}
                                >
                                    {/* <CartesianGrid vertical={false} stroke="#575757" strokeDasharray="3" /> */}
                                    <XAxis dataKey="raised_count" type="number" tick={false} tickLine={false} axisLine={false} />
                                    <YAxis dataKey="vc_class" type="category" tickMargin={15} tickLine={false} axisLine={false} label={{ value: 'Vehicle Classes', angle: -90, position: 'insideLeft', stroke: "#B2ACAC" }} />
                                    {<Tooltip content={<VCAnalysisCustomTooltip />} />}
                                    <Bar dataKey="approved_count" stackId="a" fill="#f5a604" barSize={28} />
                                    <Bar dataKey="rejected_count" stackId="a" fill="#3576ff" barSize={28} />
                                </BarChart>
                            </ResponsiveContainer>
                            <div className="axis_category">
                                <p>Raised Violation </p>
                            </div></>
                            : <>{!vcClassChartLoader && <p className="no-record-found" style={{marginTop:'50px'}}>No Record Found!</p> }</>
                            }
                        </div>
                    </div>
                </TabPanel>
            </Tabs>
        </>
    )
}
